import { LinkField, Field, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

export type IButton = {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: {
    link?: LinkField;
    screenerCtaLink?: LinkField;
    questionnaireCtaLink?: LinkField;
    buttonVariant?: {
      value: string;
    };
    /** Sitecore `Image` — optional leading asset on gradient CTAs (TA/DTP heroes). */
    image?: ImageField;
    /** Other CTA flows; not read by the gradient button (use `image` for that). */
    ctaIcon?: ImageField;
    ariaLabel?: Field<string>;
    callCenterCTAButton?: Field<boolean>;
    enableAretiChatbotNavigation?: Field<boolean>;
  };
};

export enum ButtonType {
  CONTAINED = 'contained',
  OUTLINED = 'outlined',
  TEXT = 'text',
  GRADIENT = 'gradient',
}
